/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as FileUploadService} from "../../../Services/FileUploadService";
import React from "react";

export class FileUploadFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			fileUpload: null
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		if (this.props.Value) {
			FileUploadService.GetFileUpload(this.props.Value)
				.then((x) => {
					if (x.result && x.result.fileUploadId) {
						this.setState({fileUpload: x.result});
					} else {
						this.setState({fileUpload: null});
					}
				})
				.catch((err) => this.setState({fileUpload: null}));
		} else {
			this.setState({fileUpload: null});
		}
	}

	@autobind
	_render() {
		if (this.state.fileUpload) {
			return <div className="file-upload-viewer"><a
				className="link-primary"
				onClick={() =>
					FileUploadService.DownloadFile(this.state.fileUpload.fileName, this.state.fileUpload.fileUploadId)
				}
			>
				{
					this.state.fileUpload.name
				}
			</a></div>;
		} else {
			return <div className="file-upload-viewer">N/A</div>;
		}
	}
}